//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchOperationBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"LockObjects",0,"SelectNXObjectList",0],[1,"LockPoints",0,"SelectNXObjectList",0],[1,"MotionObjects",0,"SelectNXObjectList",0],[1,"MotionPoints",0,"SelectNXObjectList",0],[1,"StationaryObject",0,"SelectNXObject",0]],[[["createConstaints"],"SetCreateConstraints",{},1,0],[[],"ClearCurrentOperation",{},0,0]],[]];
SPLM.SketchMakeRelationBuilder = class extends SPLM.SketchOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchMakeRelationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchMakeRelationBuilder.RelationTypes = Object.freeze({
    "Coincident" : "Coincident", "Collinear" : "Collinear", "Horizontal" : "Horizontal", "Vertical" : "Vertical", "Parallel" : "Parallel", "Perpendicular" : "Perpendicular", "EqualLength" : "EqualLength", "EqualRadius" : "EqualRadius", "Symmetric" : "Symmetric", "Tangent" : "Tangent", "MidpointAligned" : "MidpointAligned", "PointOnString" : "PointOnString", "TangentToString" : "TangentToString", "PerpendicularToString" : "PerpendicularToString"});

export default SPLM;